export const DirectionOptionTypeEnum = Object.freeze({
    yourPosition: 1,
    home: 2,
    work: 3,
    history: 4,
    poi: 5,
    none: 6,
    position: 7,
})